import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Language } from '../models/language.interface';

@Injectable({
    providedIn: 'root'
})
export class LanguagesService {
    private readonly http = inject(HttpClient);

    public getLanguages(): Observable<{ languages: Language[] }> {
        return this.http.get<{ languages: Language[] }>(`/assets/i18n/languages.json`);
    }
}
